import { 
  WHATNOT_CHANNEL, 
  EBAY_CHANNEL, 
  COLLX_CHANNEL,
  SHOPIFY_CHANNEL,
  ALLOWED_EBAY_TEMPLATE_FIELDS, 
  ALLOWED_WHATNOT_TEMPLATE_FIELDS,
  ALLOWED_EBAY_DIRECT_TEMPLATE_FIELDS,
  ALLOWED_SHOPIFY_TEMPLATE_FIELDS
} from '@/constants'
import { handleConnections, handleWhatnotMarketplace, handleEbayMarketplace, handleEbayTemplates, handleEbayLocations } from '../helpers/routes'

export default [
  {
    path: '/connections',
    name: 'Connections',
    meta: { requireAuth: true, requireFields: true },
    component: () => import('@/views/Connections/Channels.vue'),
    beforeEnter: handleConnections,
    children: [
      { path: 'whatnot/connect', component: () => import('@/views/Connections/ConnectionProcess/Connect.vue'), props: { ...WHATNOT_CHANNEL }, meta: { channel: 'whatnot', templatesList: 'whatnotListingTemplates' } },
      { path: 'whatnot/connected', component: () => import('@/views/Connections/ConnectionProcess/Connect.vue'), props: { ...WHATNOT_CHANNEL }, meta: { channel: 'whatnot', templatesList: 'whatnotListingTemplates' } },
      { path: 'whatnot/listing-information', component: () => import('@/views/Connections/Whatnot/ConnectionProcess/ListingInformation.vue'), meta: { channel: 'whatnot', templatesList: 'whatnotListingTemplates' }, props: { allowedFields: ALLOWED_WHATNOT_TEMPLATE_FIELDS } },
      { path: 'whatnot/profile', component: () => import('@/views/Connections/Whatnot/ConnectionProcess/Profile.vue'),  meta: { channel: 'whatnot', templatesList: 'whatnotListingTemplates' }, },

      {
        path: 'whatnot',
        component: () => import('@/views/Connections/Whatnot/index.vue'),
        children: [
          { path: '', component: () => import('@/views/Connections/Whatnot/Overview.vue') },
          { path: 'connection-settings', component: () => import('@/views/Connections/Whatnot/ConnectionSettings.vue') },
          {
            path: 'marketplace-templates',
            component: () => import('@/views/Connections/components/MarketplaceTemplate.vue'),
            beforeEnter: handleWhatnotMarketplace,
            props: {
              title: 'Marketplace Templates' ,
              addButtonLabel: 'Add New Marketplace Template',
              listingTemplatesKey: 'whatnotListingTemplates',
              allowedFields: ALLOWED_WHATNOT_TEMPLATE_FIELDS
            }
          },
          {
            path: 'history/:type',
            component: () => import('./RouterView.vue'),
            children: [
              { path: '', component: () => import('@/views/Connections/components/HistoryList/index.vue') },
              { path: ':id', component: () => import('@/views/Connections/components/HistoryDetails/index.vue'), props: { ...WHATNOT_CHANNEL } },
            ]
          },
        ]
      },

      { path: 'ebay/connect', component: () => import('@/views/Connections/ConnectionProcess/Connect.vue'), props: { ...EBAY_CHANNEL }, meta: { channel: 'ebay', templatesList: 'listingTemplates' } },
      { path: 'ebay/connected', component: () => import('@/views/Connections/ConnectionProcess/Connect.vue'), props: { ...EBAY_CHANNEL }, meta: { channel: 'ebay', templatesList: 'listingTemplates' } },
      { path: 'ebay/marketplace-listing-information', component: () => import('@/views/Connections/EbayDetails/ConnectionProcess/MarketplaceListingInformation.vue'),  meta: { channel: 'ebay', templatesList: 'marketplaceListingTemplates' }, },
      { path: 'ebay/policies', beforeEnter: handleEbayLocations, component: () => import('@/views/Connections/EbayDetails/ConnectionProcess/Policy.vue'),  meta: { channel: 'ebay', templatesList: 'marketplaceListingTemplates' }, },
      { path: 'ebay/export/shipping-settings', component: () => import('@/views/Connections/EbayDetails/ListingTemplate/ShippingSettings.vue') },
      { path: 'ebay/export/payment-return-settings', component: () => import('@/views/Connections/EbayDetails/ListingTemplate/PaymentReturnSettings.vue') },
      { path: 'ebay/export/listing-information', component: () => import('@/views/Connections/EbayDetails/ListingTemplate/ListingInformation.vue') },
      {
        path: 'ebay',
        component: () => import('@/views/Connections/EbayDetails/index.vue'),
        children: [
          { path: '', component: () => import('@/views/Connections/EbayDetails/Overview.vue') },
          {
            path: 'marketplace-templates',
            component: () => import('@/views/Connections/components/MarketplaceTemplate.vue'),
            beforeEnter: handleEbayMarketplace,
            props: {
              title: 'Marketplace Listing Templates' ,
              addButtonLabel: 'Add New Marketplace Listing Template',
              listingTemplatesKey: 'marketplaceListingTemplates',
              allowedFields: ALLOWED_EBAY_DIRECT_TEMPLATE_FIELDS
            }
          },
          {
            path: 'templates',
            component: () => import('@/views/Connections/components/MarketplaceTemplate.vue'),
            beforeEnter: handleEbayTemplates,
            props: {
              title: 'Listing Templates' ,
              addButtonLabel: 'Add New Listing Template',
              listingTemplatesKey: 'listingTemplates',
              allowedFields: ALLOWED_EBAY_TEMPLATE_FIELDS
            }
          },
          { path: 'connection-settings', component: () => import('@/views/Connections/EbayDetails/ConnectionSettings.vue') },
          { path: 'my-locations', beforeEnter: handleEbayLocations, component: () => import('@/views/Connections/EbayDetails/Locations/MyLocations.vue') },
          {
            path: 'history/:type',
            component: () => import('./RouterView.vue'),
            children: [
              { path: '', component: () => import('@/views/Connections/components/HistoryList/index.vue') },
              { path: ':id', component: () => import('@/views/Connections/components/HistoryDetails/index.vue'), props: { ...EBAY_CHANNEL } },
            ]
          },
        ]
      },
      {
        path: 'collx',
        component: () => import('@/views/Connections/CollxDetails/index.vue'),
        children: [
          { path: '', component: () => import('@/views/Connections/CollxDetails/Overview.vue') },
          // { path: 'listing-information', component: () => import('@/views/Connections/CollxDetails/ListingInformation.vue') },
          { path: 'connection-settings', component: () => import('@/views/Connections/CollxDetails/ConnectionSettings.vue') },
          {
            path: 'history/:type',
            component: () => import('./RouterView.vue'),
            children: [
              { path: '', component: () => import('@/views/Connections/components/HistoryList/index.vue') },
              { path: ':id', component: () => import('@/views/Connections/components/HistoryDetails/index.vue'), props: { ...COLLX_CHANNEL } },
            ]
          },
        ]
      },
      {
        path: 'collx/account-connection',
        component: () => import('@/views/Connections/CollxDetails/Connection/AccountConnection.vue'),
        meta: { channel: 'collx', templatesList: 'collxListingTemplates' }
      },
      {
        path: 'collx/listing-information',
        component: () => import('@/views/Connections/CollxDetails/Connection/ListingInformation.vue'),
        meta: { channel: 'collx', templatesList: 'collxListingTemplates' }
      },
      {
        path: 'shopify',
        component: () => import('@/views/Connections/ShopifyDetails/index.vue'),
        children: [
          { path: '', component: () => import('@/views/Connections/ShopifyDetails/Overview.vue') },
          {
            path: 'history/:type',
            component: () => import('./RouterView.vue'),
            children: [
              { path: '', component: () => import('@/views/Connections/components/HistoryList/index.vue') },
              { path: ':id', component: () => import('@/views/Connections/components/HistoryDetails/index.vue'), props: { ...SHOPIFY_CHANNEL } },
            ]
          },
          {
            path: 'export-settings',
            component: () => import('@/views/Connections/ShopifyDetails/ExportSettings.vue')
          },
        ]
      },
      {
        path: 'shopify/connect',
        component: () => import('@/views/Connections/ShopifyDetails/Connection/Connect.vue'),
        meta: { channel: 'shopify', templatesList: 'shopifyListingTemplates' }
      },
      {
        path: 'shopify/listing-information',
        component: () => import('@/views/Connections/ShopifyDetails/Connection/ListingInformation.vue'),
        meta: { channel: 'shopify', templatesList: 'shopifyListingTemplates' },
        props: { allowedFields: ALLOWED_SHOPIFY_TEMPLATE_FIELDS }
      },
      // { path: ':channel', component: () => import('@/views/Connections/legacy/ChannelDetails.vue') },
    ]
  }
]
